






import { defineComponent, PropType } from '@vue/composition-api';

import BookStoreTagItem from './BookStoreTagItem.vue';
import { BookStoreDTO } from '@/apis/repositories/types/@type';

export default defineComponent({
  name: 'BookStoreTagList',
  components: { BookStoreTagItem },
  props: {
    list: {
      type: Array as PropType<BookStoreDTO[]>,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
